import { AttributeType } from "@evergis/api";
import { SystemAttributeOption } from "./types";

export const SYS_ATTRIBUTES_REQUEST = [
  {
    id: SystemAttributeOption.DateOfCreate,
    attributeName: SystemAttributeOption.DateOfCreate,
    columnName: SystemAttributeOption.DateOfCreate,
    expression: "insert({now})",
    type: AttributeType.DateTime,
    stringFormat: {
      format: "dd MMMM yyyy",
      culture: "ru-RU",
    },
    sysAttribute: true,
  },
  {
    id: SystemAttributeOption.DateOfEdit,
    attributeName: SystemAttributeOption.DateOfEdit,
    columnName: SystemAttributeOption.DateOfEdit,
    expression: "update({now})",
    type: AttributeType.DateTime,
    stringFormat: {
      format: "dd MMMM yyyy",
      culture: "ru-RU",
    },
    sysAttribute: true,
  },
  {
    id: SystemAttributeOption.Author,
    attributeName: SystemAttributeOption.Author,
    columnName: SystemAttributeOption.Author,
    expression: "insert({user})",
    type: AttributeType.String,
    sysAttribute: true,
  },
  {
    id: SystemAttributeOption.LastEditor,
    attributeName: SystemAttributeOption.LastEditor,
    columnName: SystemAttributeOption.LastEditor,
    expression: "update({user})",
    type: AttributeType.String,
    sysAttribute: true,
  },
];

export const SYS_ATTRIBUTES = [
  SystemAttributeOption.DateOfCreate,
  SystemAttributeOption.DateOfEdit,
  SystemAttributeOption.Author,
  SystemAttributeOption.LastEditor,
];
